export default __webpack_public_path__ + "static/media/roundel_tab@2x.3e3408f3.png";